import React, { useState, useEffect } from 'react';

const Preloader = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length < 3 ? prevDots + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="preloader flex flex-col justify-center items-center h-screen">
      <div className="loader animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
      <div className="mt-4 text-lg font-medium">
        Loading{dots}
      </div>
    </div>
  );
};

export default Preloader;
